import { useParams, useLocation } from 'react-router-dom';
import ScheduleCardClassRoom from '../ScheduleComponent/ScheduleCardClassRoom.jsx';
import { ScheduleData } from '../../hook/ScheduleData.js';

function ClassRoomScheduleDetail() 
{
    const { classroomName } = useParams();
    const location = useLocation();

    const vo = location.state?.item?.vo ?? null;
    
    const voParam = vo === true ? 'vo' : (vo === false ? 'spo' : null);

    const { data: scheduleData, loading, error } = ScheduleData('/ClassRoom', String(classroomName),  voParam );

    if (loading) return <div className='loading'>Загрузка расписания...</div>;
    if (error)   return <div className='error'>Ошибка: {error}</div>;

    return <ScheduleCardClassRoom scheduleData={scheduleData} />;
}

export default ClassRoomScheduleDetail;